/* ─── KADOSH THEME JS ─── */

// ─── NAVBAR SCROLL ───
window.addEventListener('scroll', () => {
  document.getElementById('navbar').classList.toggle('scrolled', window.scrollY > 20);
});

// ─── MOBILE MENU ───
function toggleMobile() {
  const menu = document.getElementById('mobileMenu');
  const ham  = document.getElementById('hamburger');
  menu.classList.toggle('open');
  ham.classList.toggle('open');
  document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
}
function closeMobile() {
  document.getElementById('mobileMenu').classList.remove('open');
  document.getElementById('hamburger').classList.remove('open');
  document.body.style.overflow = '';
}

// ─── CART ───
function openCart() {
  document.getElementById('cartSidebar').classList.add('open');
  document.getElementById('overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cartSidebar').classList.remove('open');
  document.getElementById('overlay').classList.remove('open');
  document.body.style.overflow = '';
}

async function addToCart(e, variantId) {
  e.preventDefault();
  e.stopPropagation();
  try {
    const res = await fetch(window.shopData.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    const item = await res.json();
    if (item.status) {
      showToast('Error: ' + item.description);
      return;
    }
    await refreshCart();
    showToast('✦ ' + item.title + ' añadido');
    openCart();
  } catch (err) {
    console.error(err);
    showToast('Error al añadir al carrito');
  }
}

async function changeQty(key, qty) {
  try {
    await fetch(window.shopData.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await refreshCart();
  } catch (err) { console.error(err); }
}

async function removeItem(key) {
  await changeQty(key, 0);
}

async function refreshCart() {
  try {
    const res  = await fetch(window.shopData.cartUrl + '.js');
    const cart = await res.json();
    updateCartCount(cart.item_count);
    updateCartTotal(cart.total_price);
    renderCartItems(cart.items);
  } catch (err) { console.error(err); }
}

function updateCartCount(count) {
  const el = document.getElementById('cartCount');
  if (!el) return;
  el.textContent = count;
  el.classList.toggle('visible', count > 0);
}

function updateCartTotal(price) {
  const el = document.getElementById('cartTotal');
  if (!el) return;
  el.textContent = formatMoney(price);
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function renderCartItems(items) {
  const el = document.getElementById('cartItems');
  if (!el) return;
  if (!items || items.length === 0) {
    el.innerHTML = `
      <div class="cart-empty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 01-8 0"/>
        </svg>
        <p>Tu carrito está vacío</p>
      </div>`;
    return;
  }
  el.innerHTML = items.map(item => `
    <div class="cart-item">
      <div class="cart-item-img">
        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : `<span>${item.title.slice(0,1)}</span>`}
      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        ${item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
        <div class="cart-item-price">${formatMoney(item.price)}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">−</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
          <button class="remove-item" onclick="removeItem('${item.key}')">Eliminar</button>
        </div>
      </div>
    </div>
  `).join('');
}

// ─── TOAST ───
let toastTimer;
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 3000);
}

// ─── SCROLL REVEAL ───
function initReveal() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('revealed');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
}

// ─── INIT ───
document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  // Update cart count on load
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});
});
